import React from 'react'

import { Box, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { useCustomerLeadsLimit } from 'features/customers/hooks/useCustomerLeadsLimit'

import { areLeadsUnlimited } from '@albacross/types'

import QuotaUsage from 'components/_base/QuotaUsage'

import UsageUnavailable from './UsageUnavailable'

const CustomerLeadsUsage = () => {
  const customerId = useCustomerId()
  const { data, isPending, isError } = useCustomerLeadsLimit(customerId)

  if (isPending) return <Skeleton variant="text" width={85} />
  if (isError || !data) return <UsageUnavailable />

  const { custom, current, total } = data

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      {/* Infinity, not 500000: QuotaUsage already renders an unlimited quota as such, and a bar
          against the sentinel would claim the customer is 12% of the way through a cap. */}
      <Box sx={{ flexGrow: 1 }}>
        <QuotaUsage quota={areLeadsUnlimited(total) ? Infinity : total} usage={current} />
      </Box>
      {custom && (
        <Tooltip title="This customer has a limit of their own rather than the plan's">
          <Typography color="text.secondary" variant="caption">
            custom
          </Typography>
        </Tooltip>
      )}
    </Stack>
  )
}

export default CustomerLeadsUsage
